import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FunnelLayout from "../FunnelLayout";
import { useFunnelForm } from "../useFunnelForm";

function SearchHeartIcon({ size = 56 }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="13" cy="13" r="9" />
      <line x1="21" y1="21" x2="28" y2="28" />
      <path
        d="M13 17.5c-3-2-5.5-3.5-5.5-6 0-1.5 1.2-2.5 2.5-2.5 1 0 1.8 0.6 3 1.7 1.2-1.1 2-1.7 3-1.7 1.3 0 2.5 1 2.5 2.5 0 2.5-2.5 4-5.5 6z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

function SparkleIcon({ size = 12 }) {
  return (
    <svg viewBox="0 0 12 12" width={size} height={size} aria-hidden="true">
      <path
        d="M6 0L7.2 4.8L12 6L7.2 7.2L6 12L4.8 7.2L0 6L4.8 4.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

function ClipboardCheckIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="6" y="4" width="12" height="17" rx="2" />
      <path d="M9 4V3a1 1 0 011-1h4a1 1 0 011 1v1" />
      <polyline points="9 13 11 15 15 11" />
    </svg>
  );
}

function LocationPinIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function SearchIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.5" y2="16.5" />
    </svg>
  );
}

function HeadsetIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 14v-2a8 8 0 0116 0v2" />
      <rect x="3" y="14" width="4" height="6" rx="1.2" />
      <rect x="17" y="14" width="4" height="6" rx="1.2" />
      <path d="M21 18v1a2 2 0 01-2 2h-3" />
    </svg>
  );
}

function CheckIcon({ size = 14 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function SpinnerIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.22" strokeWidth="3" />
      <path d="M12 3a9 9 0 019 9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function ShieldCheckIcon({ size = 26 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  );
}

function PhoneIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  );
}

function AgentsIllustration() {
  return (
    <svg
      className="fv2-step5-agents-svg"
      viewBox="0 0 110 56"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="22" cy="28" r="13" fill="#dbeafe" />
      <circle cx="22" cy="23" r="5" fill="#1e3a8a" />
      <path d="M13 38c0-4 4-7 9-7s9 3 9 7v3H13z" fill="#1e3a8a" />
      <path d="M12 23c0-7 4-11 10-11s10 4 10 11" stroke="#059669" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <circle cx="12" cy="23" r="1.8" fill="#059669" />
      <circle cx="32" cy="23" r="1.8" fill="#059669" />

      <circle cx="55" cy="30" r="16" fill="#bbf7d0" />
      <circle cx="55" cy="25" r="6" fill="#1e3a8a" />
      <path d="M44 42c0-5 5-9 11-9s11 4 11 9v3H44z" fill="#1e3a8a" />
      <path d="M43 25c0-8 5-13 12-13s12 5 12 13" stroke="#059669" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <circle cx="43" cy="25" r="2" fill="#059669" />
      <circle cx="67" cy="25" r="2" fill="#059669" />

      <circle cx="88" cy="28" r="13" fill="#dbeafe" />
      <circle cx="88" cy="23" r="5" fill="#1e3a8a" />
      <path d="M79 38c0-4 4-7 9-7s9 3 9 7v3H79z" fill="#1e3a8a" />
      <path d="M78 23c0-7 4-11 10-11s10 4 10 11" stroke="#059669" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <circle cx="78" cy="23" r="1.8" fill="#059669" />
      <circle cx="98" cy="23" r="1.8" fill="#059669" />
    </svg>
  );
}

function StatusIndicator({ state }) {
  if (state === "done") {
    return (
      <span className="fv2-step5-status fv2-step5-status-done" aria-label="Complete">
        <CheckIcon />
      </span>
    );
  }
  if (state === "active") {
    return (
      <span className="fv2-step5-status fv2-step5-status-active" aria-label="In progress">
        <SpinnerIcon />
      </span>
    );
  }
  return (
    <span className="fv2-step5-status fv2-step5-status-pending" aria-label="Pending" />
  );
}

const ROWS = [
  {
    icon: ClipboardCheckIcon,
    title: "Reviewing your information",
    body: "Perfect! We've received your details."
  },
  {
    icon: LocationPinIcon,
    title: "Checking plans in your area",
    body: "Comparing coverage and network options."
  },
  {
    icon: SearchIcon,
    title: "Finding the best-fit matches",
    body: "Match score, benefits, and pricing."
  },
  {
    icon: HeadsetIcon,
    title: "Preparing your personalized results",
    body: "A licensed representative may call to review."
  }
];

const MILESTONES = [
  { t: 0, p: 0 },
  { t: 2200, p: 25 },
  { t: 4500, p: 50 },
  { t: 6800, p: 75 },
  { t: 9000, p: 100 }
];

const STAGE_TIMES = [0, 2200, 4500, 6800, 9000];

const NAV_DELAY = 10000;

export default function Step5() {
  const navigate = useNavigate();
  const { update } = useFunnelForm();

  const [progress, setProgress] = useState(0);
  const [stage, setStage] = useState(0);

  useEffect(() => {
    let raf;
    let navTimer;
    const start = performance.now();

    const tick = (now) => {
      const elapsed = now - start;

      let p = 100;
      for (let i = 0; i < MILESTONES.length - 1; i++) {
        const a = MILESTONES[i];
        const b = MILESTONES[i + 1];
        if (elapsed >= a.t && elapsed < b.t) {
          const frac = (elapsed - a.t) / (b.t - a.t);
          p = a.p + (b.p - a.p) * frac;
          break;
        }
      }
      if (elapsed >= MILESTONES[MILESTONES.length - 1].t) p = 100;

      let s = 0;
      for (let i = 0; i < STAGE_TIMES.length; i++) {
        if (elapsed >= STAGE_TIMES[i]) s = i;
      }

      setProgress(Math.min(100, p));
      setStage(s);

      if (elapsed < MILESTONES[MILESTONES.length - 1].t) {
        raf = requestAnimationFrame(tick);
      }
    };

    raf = requestAnimationFrame(tick);

    navTimer = setTimeout(() => {
      update("step5", { reviewedAt: new Date().toISOString() });
      navigate("/v2/step-6");
    }, NAV_DELAY);

    return () => {
      if (raf) cancelAnimationFrame(raf);
      if (navTimer) clearTimeout(navTimer);
    };
    // Mount-once effect: runs the animation timeline and cleans up on unmount.
    // `update` and `navigate` are intentionally not in the deps array.
  }, []);

  const getRowState = (idx) => {
    if (idx < stage) return "done";
    if (idx === stage) return "active";
    return "pending";
  };

  return (
    <FunnelLayout currentStep={5}>
      <div className="fv2-step5">
        <div className="fv2-step5-hero">
          <span className="fv2-step5-sparkle fv2-step5-sparkle-tl" aria-hidden="true">
            <SparkleIcon size={12} />
          </span>
          <span className="fv2-step5-sparkle fv2-step5-sparkle-tr" aria-hidden="true">
            <SparkleIcon size={8} />
          </span>
          <span className="fv2-step5-sparkle fv2-step5-sparkle-br" aria-hidden="true">
            <SparkleIcon size={10} />
          </span>
          <div className="fv2-step5-hero-circle">
            <SearchHeartIcon size={48} />
          </div>
        </div>

        <h1 className="fv2-step5-h1">We're Finding Your Best Options</h1>

        <p className="fv2-step5-sub">
          <span>This usually takes less than 30 seconds.</span>
          <span>Thanks for your patience!</span>
        </p>

        <div className="fv2-step5-card">
          <h3 className="fv2-step5-card-h">
            Reviewing plans for your household...
          </h3>

          <div className="fv2-step5-bar-row">
            <div
              className="fv2-step5-bar"
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={Math.round(progress)}
            >
              <div
                className="fv2-step5-bar-fill"
                style={{ transform: `scaleX(${progress / 100})` }}
              />
            </div>
            <span className="fv2-step5-bar-pct">{Math.round(progress)}%</span>
          </div>

          <div className="fv2-step5-rows">
            {ROWS.map((row, idx) => {
              const Icon = row.icon;
              const state = getRowState(idx);
              return (
                <div className="fv2-step5-row" key={row.title}>
                  <span className="fv2-step5-row-icon">
                    <Icon />
                  </span>
                  <div className="fv2-step5-row-text">
                    <strong>{row.title}</strong>
                    <p>{row.body}</p>
                  </div>
                  <span className="fv2-step5-row-status">
                    <StatusIndicator state={state} />
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="fv2-step5-trust">
          <div className="fv2-step5-trust-left">
            <span className="fv2-step5-trust-icon">
              <ShieldCheckIcon size={26} />
            </span>
            <div className="fv2-step5-trust-text">
              <strong>You're in good hands.</strong>
              <p>
                Our licensed agents will help you find affordable, quality
                coverage that fits your needs.
              </p>
            </div>
          </div>
          <div className="fv2-step5-trust-right">
            <AgentsIllustration />
          </div>
        </div>

        <div className="fv2-step5-callcard">
          <span className="fv2-step5-callcard-icon">
            <PhoneIcon />
          </span>
          <div className="fv2-step5-callcard-text">
            <strong>Want your results even faster?</strong>
            <p>Call now to speak with a licensed agent.</p>
          </div>
          <a
            className="fv2-step5-callcard-btn"
            href="tel:+18337212356"
          >
            <PhoneIcon size={16} />
            (833) 721-2356
          </a>
        </div>

        <p className="fv2-step5-secure">
          <LockIcon /> Your information is secure and confidential.
        </p>
      </div>
    </FunnelLayout>
  );
}
